import { theme } from './bulk.styles';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { MultiImagePicker } from 'app/design/primitives/multi-image-picker';
import { Text } from 'app/design/primitives/text';
import { BULK_LISTING_MAX_PHOTOS } from 'app/network/listing';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import type { ImagePickerAsset } from 'expo-image-picker';
import { useTranslation } from 'react-i18next';
import { Signal } from 'app/design/icons/signal';

export function PhotoSelectionStep({
  isBusy,
  onContinue,
  onPhotosChange,
  onOpenCamera,
  photos,
}: {
  isBusy: boolean;
  onContinue: () => void;
  onPhotosChange: (photos: ImagePickerAsset[]) => void;
  onOpenCamera: () => void;
  photos: ImagePickerAsset[];
}) {
  const { t } = useTranslation('new');
  const canContinue = photos.length > 0;

  return (
    <Column gap="spacing.general.x5">
      <MultiImagePicker
        disabled={isBusy}
        images={photos}
        maxImages={BULK_LISTING_MAX_PHOTOS}
        showCoverLabels={false}
        onChange={onPhotosChange}
        onOpenCamera={onOpenCamera}
        title={t('bulk.photoSelection.addPhotos')}
        withInlinePicker
      />

      <Button disabled={!canContinue || isBusy} onPress={onContinue} variant="primary">
        <Signal strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['surface.default']} size={20} />
        <Text color="surface.default" marginLeft="spacing.general.x2">
          {t('bulk.photoSelection.generate')}
        </Text>
      </Button>
    </Column>
  );
}
